import * as React from 'react';
import * as _ from 'lodash';
import PagerEx from '../../../components/PageLayout/PagerEx';
import { AdjustPricingCard } from '../../../components/StoneSetup/AssignPricing/card';
export default function () {
    function repeatStone1(stone, stoneIndex) {
        return [React.createElement(AdjustPricingCard, {
                'stone': stone,
                'onSelectionToggled': this.props.selectStone,
                'key': '2941'
            })];
    }
    return React.createElement('div', { 'className': 'app-content-main' }, React.createElement('div', { 'className': 'assign-container' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-list' },
        _.map(this.props.enabledStones[this.state.page], repeatStone1.bind(this))
    ]), false ? React.createElement(PagerEx, {
        'pageCount': this.props.totalPages,
        'forcePage': this.state.page,
        'onPageChange': page => this.setPage(page),
        'key': '502'
    }) : null));
}